import {Injectable, NgZone} from '@angular/core';
import {Subject} from 'rxjs';
import {StatutWebsocketDto} from './statut-websocket-dto.model';

@Injectable({
	providedIn: 'root'
})
export class NotificationServiceJsVersStatutWebsocketService {

	private static INTERVALLE_RECONNEXION_EN_MILLISECONDES = 5_000; // 5 secondes
	private static MAX_INTERVALLE_RECONNEXION_EN_MILLISECONDES = 30_000; // 30 secondes

	private intervalleReconnexion = 500; // on commence à 500ms pour la phase de connexion initiale

	private statutWebsocket: StatutWebsocketDto;

	notificationStatutWebsocketSubject = new Subject<StatutWebsocketDto>();
	notificationDemandeConnexionWebsocketSubject = new Subject<void>();

	constructor(private ngZone: NgZone) {
	}

	/**
	 * Tâche de scrutation et de reconnexion au websocket.
	 * Au lancement on essaie de se connecter tout de suite.
	 * Par la suite toutes les 5 secondes on scrute l'état.
	 * Si la connexion n'est plus effective, on tente la reconnexion toutes les 5/10/15/20/25/30 secondes.
	 * On limite le temps d'attente à 30 secondes
	 */
	public initTacheReconnexion() {
		this.ngZone.runOutsideAngular(() => {
			setTimeout(() => {
				if (!this.estWebsocketConnectee()) {
					// à chaque tentative de reconnexion, on rajoute 5 secondes avant la prochaine tentative,
					this.intervalleReconnexion = Math.min(this.intervalleReconnexion + NotificationServiceJsVersStatutWebsocketService.INTERVALLE_RECONNEXION_EN_MILLISECONDES, NotificationServiceJsVersStatutWebsocketService.MAX_INTERVALLE_RECONNEXION_EN_MILLISECONDES);
					this.demanderConnexion();
				}
				// Si on est connecté, on réinitialise l'interval à la valeur de départ
				else {
					this.intervalleReconnexion = NotificationServiceJsVersStatutWebsocketService.INTERVALLE_RECONNEXION_EN_MILLISECONDES;
				}
				this.initTacheReconnexion();
			}, this.intervalleReconnexion);
		});
	}

	/**
	 * Détermine si la connexion au websocket a été faites
	 */
	estWebsocketConnectee(): boolean {
		return this.statutWebsocket && this.statutWebsocket.estConnectee;
	}

	/**
	 * Poste le statut des websocket
	 *
	 * @param statutWebsocket true si la connexion a été faites
	 * @param avecTemporisation true si on veut une temporisation avant de relayer le message
	 */
	posterStatutWebsocket(statutWebsocket: boolean, avecTemporisation: boolean): void {
		this.statutWebsocket = new StatutWebsocketDto(statutWebsocket, Date.now());
		if (avecTemporisation) {
			// ajout d'une tempo pour être sûr que le composant statut websocket a bien eu le temps de subscribe sur le subject en question
			setTimeout(() => {
				this.notificationStatutWebsocketSubject.next(this.statutWebsocket);
			}, 1000);
		}
		else {
			this.notificationStatutWebsocketSubject.next(this.statutWebsocket);
		}
	}

	/**
	 * Demande la connexion au websocket
	 */
	demanderConnexion() {
		this.notificationDemandeConnexionWebsocketSubject.next();
	}
}
